jQuery(function ($) {
	/*
		//Notice Function
		function show_notice(notice_type, notice) {
			$('.mint-notice').html(notice).attr('class', 'mint-notice').addClass('mint-nt-' + notice_type);
			$('.mint-notice-box').fadeIn('fast');
			clearTimeout(fadenotice);
			var fadenotice = setTimeout(function () {
				$('.mint-notice-box').fadeOut('fast');
			}, 6000);
		}
		//Add to cart function
		function add_to_cart(atc_btn, form_data) {
	
			// Trigger event.
			$(document.body).trigger('adding_to_cart', [atc_btn, form_data]);
	
			$.ajax({
				url: mintAjax.wc_ajax_url.toString().replace('%%endpoint%%', 'mint_add_to_cart'),
				type: 'POST',
				data: $.param(form_data),
				success: function (response) {
	
					$('.mint-cart-adding', atc_btn).remove();
	
					if (response.fragments) {
						// Trigger event so themes can refresh other areas.
						$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, atc_btn]);
						atc_btn.append('<i class="icon-checkmark mint-cart-added"></i>');
					} else if (response.error) {
						show_notice('error', response.error);
						//open_popup();
					} else {
						$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, atc_btn]);
						$(document.body).trigger('wc_fragment_refresh');
					}
	
				}
			})
		}
		//Add to cart on single page
		$(document).on('submit', 'form.cart', function (e) {
			e.preventDefault();
	
			var form = $(this);
			var atc_btn = form.find('button[type="submit"]');
	
			$('.mint-cart-added', atc_btn).remove();
			atc_btn.append('<i class="icon-spinner mint-cart-adding"></i>');
			atc_btn.addClass('loading');
	
			var form_data = form.serializeArray();
	
			// if button as name add-to-cart get it and add to form
			if (atc_btn.attr('name') && atc_btn.attr('name') == 'add-to-cart' && atc_btn.attr('value')) {
				form_data.push({
					name: 'add-to-cart',
					value: atc_btn.attr('value')
				});
			}
	
			form_data.push({
				name: 'action',
				value: 'mint_add_to_cart'
			});
	
			add_to_cart(atc_btn, form_data); //Ajax add to cart
		})
	
		var mint_added_to_cart = function (e, fragments, cart_hash, $button) {
			console.log(fragments);
			$button = typeof $button === 'undefined' ? false : $button;
			if ($button) {
				// View cart text.
				if (fragments && !wc_add_to_cart_params.is_cart && $button.parent().find('.mint_added_to_cart').length === 0) {
					$button.after('<a href="' + wc_add_to_cart_params.cart_url + '" class="btn btn-outline-gray3 mint_added_to_cart position-relative" style="display:none" title="' +
						wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + fragments['.mint-cart-btn-count'] + '</a>');
						$button.fadeOut('fast', function() {
							$button.parent().find('.mint_added_to_cart').fadeIn('fast');
						  });
				} else if (fragments && !wc_add_to_cart_params.is_cart && $button.parent().find('.mint_added_to_cart').length) {
					$button.fadeOut('fast', function() {
						$button.parent().find('.mint_added_to_cart').fadeIn('fast');
					  });
				}
				setTimeout(function () {
					$button.parent().find('.mint_added_to_cart').fadeOut('fast', function() {
						// This code runs after the fade-out animation is complete
						// Apply a fade-in effect to the button
						$button.fadeIn('fast');
					  });
				}, 6000);
	
				$(document.body).trigger('mint_cart_button_updated', [$button]);
			}
		};
	
	
		$(document.body).on('added_to_cart', mint_added_to_cart);
	
	
		function handleCartInput() {
			if ($('.mint_added_to_cart').length) {
				var $button = $(this).closest('form.cart').find('button[type="submit"]');
				$('.mint_added_to_cart').hide();
				$button.show();
			}
		}
	
		// Bind the function to the 'click' event for elements with class '.qib-select'
		$('.qib-button').on('click', handleCartInput);
	
		// Bind the same function to the 'input' event for 'form.cart input.qty' elements
		$('form.cart input.qty').on('input', handleCartInput);
	
		//Update cart
		function update_cart(cart_key, new_qty) {
			cart_loading();
			$.ajax({
				url: mintAjax.wc_ajax_url.toString().replace('%%endpoint%%', 'mint_update_cart'),
				type: 'POST',
				data: {
					cart_key: cart_key,
					new_qty: new_qty
				},
				success: function (response) {
					if (response.fragments) {
						refresh_fragments(response);
					} else {
						show_notice('error', response.error);
					}
					cart_loaded();
				}
	
			})
		}
	
		//Save Quantity on focus
		$(document).on('focusin', '#mint-mini-cart input.qty', function () {
			var focus_qty = $(this).val();
		})
	
	
		//Qty input on change
		$(document).on('change', '#mint-mini-cart input.qty', function (e) {
			var _this = $(this);
			var new_qty = parseFloat($(this).val());
			var step = parseFloat($(this).attr('step'));
			var min_value = parseFloat($(this).attr('min'));
			var max_value = parseFloat($(this).attr('max'));
			var invalid = false;
	
	
			if (new_qty === 0) {
				_this.closest('li').find('.remove-from-cart').trigger('click');
				return;
			}
			//Check If valid number
			else if (isNaN(new_qty) || new_qty < 0) {
				invalid = true;
			}
	
			//Check maximum quantity
			else if (new_qty > max_value && max_value > 0) {
				alert('Maximum Quantity: ' + max_value);
				invalid = true;
			}
	
			//Check Minimum Quantity
			else if (new_qty < min_value) {
				invalid = true;
			}
	
			//Check Step
			else if ((new_qty % step) !== 0) {
				alert('Quantity can only be purchased in multiple of ' + step);
				invalid = true;
			}
	
			//Update if everything is fine.
			else {
				var cart_key = $(this).closest('li').data('cart-item-key');
				update_cart(cart_key, new_qty);
			}
	
			if (invalid === true) {
				$(this).val(focus_qty);
			}
	
		})
	
		$('form.checkout').on('change', 'select[name="billing_state"]', function () {
			$(document.body).trigger('update_checkout');
		});
	
		$("#mint_email").on("input", function () {
			// Update the hidden email field with the value from the visible field
			$("#billing_email").val($(this).val());
		});
	*/
	
	if ($('#stock-modal').length) {
		var got_stock = false,
			stock_modal = new mint.Modal(document.getElementById('stock-modal'));
		$(document).on('click', '#get_stock', function () {
			if (!got_stock) {
				$.ajax({
					url: mintAjax.ajaxurl, // AJAX handler
					data: {
						'action': 'mint_get_product_stock', // the parameter for admin-ajax.php
						'product_id': $(this).closest('form').data('product_id'), // loop parameters passed by wp_localize_script()
					},
					type: 'POST',
					beforeSend: function () {
						$('#stock-modal .modal-body').text('Loading...'); // some type of preloader
					},
					success: function (response) {
						if (response) {
							$('#stock-modal .modal-body').html(response['html']);
							stock_modal.show();
							got_stock = true;
						}
					}
				});
			} else {
				stock_modal.show();
			}

		});
	}

})
